import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SocialIcons from './SocialIcons';
import Nav from './FooterNav';
import Container from '../../common/Container';
import Logo from '../../common/Logo';
import i18next from 'i18next';
export default function Footer() {
    const navSections = [
        {
            title: 'Help',
            links: [
                [
                    'customer-support',
                    i18next.language == 'it' ? '/contatti' : '/contact',
                ],
                ['blog', '/blog'],
                ['faq', '/support'],
            ],
        },
        {
            title: 'Legal',
            links: [
                ['terms-n-conditions', '/terms-of-use'],
                ['privacy-policy', '/privacy-policy'],
                ['cookies', '/privacy-policy#cookies'],
            ],
        },
    ];
    return (_jsx("footer", { className: "py-6 text-day-mode-text-primary md:py-12 lg:py-16", children: _jsx(Container, { children: _jsxs("div", { className: "space-y-8 sm:flex sm:flex-col sm:space-y-14", children: [_jsxs("div", { className: "space-y-8 sm:flex sm:space-x-12 sm:space-y-0 md:space-x-24", children: [_jsxs("div", { className: "space-y-8", children: [_jsx(Logo, { className: "w-60" }), _jsx(SocialIcons, {})] }), _jsx(Nav, { sections: navSections })] }), _jsxs("p", { className: "text-sm text-day-mode-text-secondary", children: ["Copyright \u00A9 ", new Date().getFullYear(), " Together Price Ltd - 38 Craven Street, London, WC2N 5NG, UK"] })] }) }) }));
}
